(function () {
    'use strict';
    var controllerId = 'didatticaCompetenzaAdd';
    angular.module('app').controller(controllerId, ['$scope','$rootScope', 'datacontext', 'sectionMenu', '$uibModalInstance', 'materie', didatticaCompetenzaAddFn]);

    function didatticaCompetenzaAddFn($scope, $rootScope, datacontext, sectionMenu, $uibModalInstance, materie) {

        
        var flag = 0;
        $scope.materie = materie;
        $scope.anniScolastici = $rootScope.anniScolastici;
        $scope.didatticaAdd = {};
        $scope.didatticaAdd.Anno = $rootScope.annoCorrente || (new Date).getFullYear();


        $scope.ok = function (isValid) {
            if (isValid) {
                var result = datacontext.schedaCompetenzeDoc_add($scope.didatticaAdd).then(function (data) {
                    return data;
                });
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };         
    }
})();